import { Auth } from 'aws-amplify';

export const getCognitoId = async () => {
    const cognitoIdentityCredentials = await Auth.currentCredentials();
    return cognitoIdentityCredentials.identityId.split(':')[1];
};
